import { render, staticRenderFns } from "./EditTripDialog.vue?vue&type=template&id=1bb8535d&scoped=true&"
import script from "./EditTripDialog.vue?vue&type=script&lang=js&"
export * from "./EditTripDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditTripDialog.vue?vue&type=style&index=0&id=1bb8535d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb8535d",
  null
  
)

export default component.exports